import { isDirectLinkPage } from '@utils/isDirectLinkPage';
import { Source } from '@interfaces/source';

export const getPaymentSearchSource = (pathname: string): Source => {
  return isDirectLinkPage(pathname) ? Source.link : Source.web;
};
